// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-dialog {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 600px;
  height: 500px;
  border-radius: 25px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 8px;
  background-color: #ffffff;
}
.popup-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: opacity 0.3s ease;
  opacity: 0;
}

.popup-background.active {
  opacity: 1; /* Show the overlay when the 'active' class is added */
}
.photo-dialog-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 5px 10px;
}
.photo-dialog-header p {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #373334;
}
.close-icon {
  height: 25px;
  width: 25px;
  border-radius: 30px;
  background-color: #f3f2f0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: -6px;
  cursor: pointer;
}
.close-icon img {
  height: 20px;
}
.no-data-container {
  margin-top: 100px;
  min-width: 500px;
}
.no-data-container p {
  font-family: sans-serif;
  font-weight: 500;
  font-size: 15px;
}
.post-button {
  padding: 5px 25px;
  /* background-color: #6CA8E1; */
  background-image: linear-gradient(to right, #6ca8e1, rgb(0, 106, 255));
  color: #ffffff;
  border-radius: 18px;
  border-width: 0px;
}
.save-button-container {
  margin-right: auto;
  margin-top: auto !important;
}
.photo-list-container {
  display: flex;
  flex-wrap: wrap;               /* allow wrapping */
  gap: 12px;                     /* space between items */
  justify-content: flex-start;
  align-items: flex-start;
  overflow: auto;
  scrollbar-width: none;
}

/* Default: 2 per row */
.photo-list-container > * {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 12px);
  max-width: calc(50% - 12px);
  box-sizing: border-box;
}

/* If only one photo → make it fill the full width */
.photo-list-container:has(> :only-child) > * {
  flex: 1 1 100%;
  max-width: 100%;
}
.addPhotoButton {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  outline: none !important;
}
.addPhotoButton img{
  height: 12px;
}
.addPhotoButton span{
  height: 12px;
  font-weight: 600;
  font-size: 15px;
  margin-top: -8px;
}



`, "",{"version":3,"sources":["webpack://./src/views/dialogs/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,sDAAsD;AACpE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,sEAAsE;EACtE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe,gBAAgB,mBAAmB;EAClD,SAAS,sBAAsB,wBAAwB;EACvD,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".photo-dialog {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  max-width: 600px;\r\n  height: 500px;\r\n  border-radius: 25px;\r\n  padding-top: 20px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n  padding-bottom: 8px;\r\n  background-color: #ffffff;\r\n}\r\n.popup-background {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  transition: opacity 0.3s ease;\r\n  opacity: 0;\r\n}\r\n\r\n.popup-background.active {\r\n  opacity: 1; /* Show the overlay when the 'active' class is added */\r\n}\r\n.photo-dialog-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n  padding: 5px 10px;\r\n}\r\n.photo-dialog-header p {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  color: #373334;\r\n}\r\n.close-icon {\r\n  height: 25px;\r\n  width: 25px;\r\n  border-radius: 30px;\r\n  background-color: #f3f2f0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: -6px;\r\n  cursor: pointer;\r\n}\r\n.close-icon img {\r\n  height: 20px;\r\n}\r\n.no-data-container {\r\n  margin-top: 100px;\r\n  min-width: 500px;\r\n}\r\n.no-data-container p {\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n}\r\n.post-button {\r\n  padding: 5px 25px;\r\n  /* background-color: #6CA8E1; */\r\n  background-image: linear-gradient(to right, #6ca8e1, rgb(0, 106, 255));\r\n  color: #ffffff;\r\n  border-radius: 18px;\r\n  border-width: 0px;\r\n}\r\n.save-button-container {\r\n  margin-right: auto;\r\n  margin-top: auto !important;\r\n}\r\n.photo-list-container {\r\n  display: flex;\r\n  flex-wrap: wrap;               /* allow wrapping */\r\n  gap: 12px;                     /* space between items */\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  overflow: auto;\r\n  scrollbar-width: none;\r\n}\r\n\r\n/* Default: 2 per row */\r\n.photo-list-container > * {\r\n  flex: 1 1 calc(50% - 12px);\r\n  max-width: calc(50% - 12px);\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* If only one photo → make it fill the full width */\r\n.photo-list-container:has(> :only-child) > * {\r\n  flex: 1 1 100%;\r\n  max-width: 100%;\r\n}\r\n.addPhotoButton {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 5px;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n}\r\n.addPhotoButton img{\r\n  height: 12px;\r\n}\r\n.addPhotoButton span{\r\n  height: 12px;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  margin-top: -8px;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
